var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.WecouponMall,{staticClass:"cross-wecoupon-mall",attrs:{"title":_setup.i18n('深圳·商圈優惠')}})
}
var staticRenderFns = []

export { render, staticRenderFns }